import { CognitoRefreshToken, CognitoUser, CognitoUserPool, CognitoUserSession } from 'amazon-cognito-identity-js';
import { cookieStorage } from '.';

export interface IAuth {
  accessToken: string | null;
  refreshToken: string | null;
  idToken: string | null;
  challengeUsername: string | null;
  challengeSession: string | null;
  deviceKey: string | null;
}

export const refreshSession = async ({
  userPoolId,
  appClient,
  username
}: {
  userPoolId: string;
  appClient: string;
  username: string;
}): Promise<{ session: CognitoUserSession; user: CognitoUser } | null> => {
  try {
    const userPool = new CognitoUserPool({
      UserPoolId: userPoolId,
      ClientId: appClient,
      Storage: cookieStorage
    });
    const cognitoUser = new CognitoUser({
      Username: username,
      Pool: userPool,
      Storage: cookieStorage
    });
    const currentSession = await getSession(cognitoUser);
    const cognitoRefreshToken = currentSession.getRefreshToken();
    if (!cognitoRefreshToken) {
      return null;
    }

    // user.refreshSession() fails when a user has an apostrophe in their username. The refresh token API
    // request is successful and the session data is updated but the Device API request made after fails
    let userSession;
    try {
      userSession = await refreshSessionAsync(cognitoUser, cognitoRefreshToken);
    } catch (error) {
      console.error(error);
      if (error.message === 'Refresh Token has been revoked') {
        throw error;
      }
      if (username.includes("'")) {
        userSession = await getSession(cognitoUser);
      }
    }
    if (!userSession || !userSession.isValid()) {
      return null;
    }
    cognitoUser.setSignInUserSession(userSession);
    return { session: userSession, user: cognitoUser };
  } catch (error) {
    if (error.message === 'Refresh Token has been revoked') {
      throw error;
    }
    if (error.message !== 'Local storage is missing an ID Token, Please authenticate') {
      console.error(error);
    }
    return null;
  }
};

export const getSession = (user: CognitoUser): Promise<CognitoUserSession> => {
  return new Promise((resolve, reject) => {
    user.getSession((error, session) => {
      if (error) {
        reject(error);
      } else {
        resolve(session);
      }
    });
  });
};

export const refreshSessionAsync = (
  user: CognitoUser,
  refreshToken: CognitoRefreshToken
): Promise<CognitoUserSession> => {
  return new Promise((resolve, reject) => {
    user.refreshSession(refreshToken, (error, result) => {
      if (error) {
        reject(error);
      } else {
        // console.log('refreshSession', result);
        resolve(result);
      }
    });
  });
};
